import {runPostTypesConfigSync} from "../../postTypes";

const titles = {
    homeTitle: "Home",
    acceptCookiesTitle: "Accept cookies",
    ...runPostTypesConfigSync({action:"getConstants", rKey:"titles"}).reduce((a, v) => {return {...a, ...v}}, {})
};

export default titles;
